import { extendTheme } from '@chakra-ui/react';
import { theme as _theme } from '@cronos-app/chakra';

export const theme = extendTheme(_theme);
